
import { defineComponent } from "vue";
import KeycloakService from "@/services/keycloak/keycloakService";
import { RegisterService } from "./register.service";
import { ToastFactory } from "@/utils/ToastFactory";
import useVuelidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";
import User from "@/interfaces/User.interface";
import { Toast } from "bootstrap";

const regexcpf = helpers.regex(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/);

const registerService = new RegisterService();

export default defineComponent({
  name: "RegisterVue",
  data() {
    return {
      user: {} as User,
      disabledButton: false as boolean,
    };
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      user: {
        name: { required },
        cpf: { required, regexcpf },
        email: { required, email },
      },
    };
  },
  methods: {
    login() {
      return KeycloakService.CallLogin("/redirect");
    },

    async registerUser(): Promise<void> {
      this.user.cpf = this.user.cpf.replace(/\D/g, "");
      registerService
        .registerUser(this.user)
        .then((response) => {
          this.user = {} as User;
          this.$toast.add(
            ToastFactory.success(this.$t("toast.sucessRegister"))
          );
          this.disabledButton = false;
        })
        .catch((error) => {
          this.disabledButton = false;
          this.$toast.add(ToastFactory.error(this.$t("toast.errorRegister")));
        });
    },

    sendRegister(): void {
      this.v$.$touch();

      if (!this.v$.$error) {
        this.disabledButton = true;
        this.registerUser();
      }
    },
  },
});
